/*
 * @Author: Chris 
 * @Date: 2022-07-26 14:51:58 
 * @Last Modified by: Chris
 * @Last Modified time: 2022-10-27 13:47:55
 */

import {
    get,
    post,
    HUBpost,
    HUBget
} from "./request.js";

/* HUB接口 */
export const getLogin = p => HUBpost("/auth/name/phone/login", p); // PC登录接口
export const authverificationcodelogin = p => HUBpost("/auth/verification/code/login", p); // PC登录接口
export const phoneverifyCode = p => HUBget("/basic/phone/verifyCode", p); //发送验证码
export const authbasiccaptchaImage = p => HUBpost("/auth/basic/captchaImage", p); // 登录页面图形验证码获取
export const basiccheckPhone = p => HUBpost("/basic/checkPhone", p); // 登录页面图形验证码获取
export const authdeptcompanyByPhone = p => HUBget("/auth/center/dept/companyByPhone", p); //根据手机号查询用户所属公司
export const authcheckingphonecode = p => HUBpost("/auth/checking/phonecode", p); // 登录页面图形验证码获取

/* 通用接口 */
export const getqiNiutoken = p => get("/get/qiNiu/token", p); //获取七牛云token


/* 用户权限校验 */
export const loginByCode = p => get("/login/pc", p); //PC登录
export const userpersonalinformation = p => get("/auth/user/personal/information", p); //个人信息查询
export const authmenuleftList = p => get("/auth/menu/leftList", p); //个人信息查询
export const signOut = p => get("/signOut/pc", p); //个人信息查询

/* 用户管理页面 */
export const authuseruserId = p => get("/auth/user/details", p); //查询
export const generatemaster = p => post("/auth/url/master/generate", p); //主管理员生成链接
export const authurl = p => get("/auth/url", p); //主管理员生成链接校验是否过期
export const usercheckPhone = p => post("/auth/user/checkPhone", p); //校验手机号
export const authuser = p => get("/auth/user", p); //删除用户
export const userupdateStatus = p => post("/auth/user/updateStatus", p); //修改用户状态
export const authdeptupdate = p => post("/auth/dept/update", p); //修改公司或者部门
export const getUserList = p => get("/auth/dept/company/list", p); //获取用户公司列表
export const authusersetmasterUsers = p => get("/auth/user/set/masterUsers", p); //移交主管理员设置
export const getFaultList = p => get("/auth/fault/standard", p); //获取故障标准
export const getPropertyList = p => get("/auth/property/standard", p); //获取物模型标准

/* 组织架构管理页面 */
export const authuseradd = p => post("/auth/user/add", p); //新增用户
export const authdeptlist = p => get("/auth/dept/list", p); //组织架构列表
export const authuserlist = p => get("/auth/user/list", p); //用户列表
export const authuserresetPassword = p => get("/auth/user/resetPassword", p); //重置密码
export const authuserupdateStatus = p => post("/auth/user/updateStatus", p); //修改用户状态
export const authuserupdate = p => post("/auth/user/update", p); //修改用户
export const authdeptaddSub = p => post("/auth/dept/addSub", p); //新增公司子部门
export const authdept = p => get("/auth/dept", p); //删除部门及子级以及用户
export const authdeptcompany = p => get("/auth/dept/company", p); //删除部门及子级以及用户
export const authdeptmobile = p => post("/auth/dept/mobile", p); //新增公司子部门
export const authusersetsysAdmin = p => post("/auth/user/set/sysAdmin", p); //用户移动部门
export const authdeptdetails = p => get("/auth/dept/details", p); //部门详情

export const removeUserDept = p => post("/auth/user/remove/dept", p); // 将成员从某部门移除 批量
export const reUserDept = p => post("/auth/user/mobile", p); // 调整成员部门 单个
export const reUserDeptBatch = p => post("/auth/user/batch/mobile", p); // 调整成员部门 批量


/* 系统管理页面 */
export const authsyslist = p => get("/auth/sys/list", p); //获取系统列表
export const authrolelist = p => get("/auth/role/list", p); //获取角色列表
export const authroleadd = p => post("/auth/role/add", p); //新增角色
export const authroleupdate = p => post("/auth/role/update", p); //修改角色
export const authrole = p => get("/auth/role", p); //角色删除
export const authuserroleIdlist = p => get("/auth/user/roleId/list", p); //通过角色id查询成员
export const authmenuroleIdlist = p => get("/auth/menu/roleId/list", p); //通过角色id查询菜单
export const authroleaddOrDeleteUser = p => post("/auth/role/addOrDeleteUser", p); //给角色添加或者移除用户
export const authmenusetMenuroleId = p => post("/auth/menu/setMenu/roleId", p); //给角色开关菜单权限
export const authmenuadd = p => post("/auth/menu/add", p); //新增菜单
export const authuserroleIddeptAndUserList = p => get("/auth/user/roleId/deptAndUserList", p); //通过角色id查询菜单

/** 使用单位管理 */
export const useCompanyList = p => get("/auth/dept/company/unitUseList", p); // 使用单位列表
export const useCompanyEdit = p => post("/auth/dept/company/updateUnitUse", p); // 修改使用单位
export const useCompanyRemove = p => post("/auth/dept/company/dissolveTheRelationship", p); // 解除使用单位
export const adminCompanyList = p => get("/auth/dept/company/maintenceList", p); //使用单位管理页面，admin登录时，维保公司列表

export const usercheckPhoneUseCompany = p => post("/unitUseUser/checkPhone", p); //校验手机号

export const checkUseCompanyName = p => get("/auth/dept/check/companyName", p); //校验使用公司名字是否重复


/**
 * 菜单管理
 */
export const menuList = p => get("/getMenu", p); // 菜单列表
export const menuAdd = p => post("/addMenu", p); // 菜单列表
export const menuDelete = p => get("/rmMenu", p); // 菜单列表
export const menuEdit = p => post("/updMenu", p); // 菜单列表
// 公司类型列表
export const getCompanyTypeList = p => get("/getUnitType", p);

/***
 * 邀请链接生成通用方法
 */
export const createInvateLink = p => post("/auth/url/ordinary/generate", p);
/**
 * 注册
 */
// 公司用户注册通用方法
export const createUserOrCompany = p => post("/auth/user/urlAddUser", p);
// 校验邀请码
export const checkPromotionNum = p => get("/auth/user/checkPromotionNum", p);
// 邀请码注册
export const invitationCode = p => post("/auth/user/invitationCode", p);
// 感兴趣的内容
export const addInterested = p => post("/auth/user/interested", p);
// 校验推广人员的链接是否过期
export const authPromotionUrl = p => get("/auth/user/checkUrl", p);
// 确认成为推二级广员
export const addLevelTwo = p => post("/auth/user/addLevelTwo", p);
